<template>
  <form-field>
    <b-checkbox-button
      v-for="item in items"
      :key="item.value"
      v-model="checkboxGroup"
      :native-value="item.value"
      type="is-white"
      size="is-small"
      @input="handleInput"
    >
      <icon-default v-if="checkboxGroup.includes(item.value)" icon="check" size="is-small" color="is-success"></icon-default>
      <icon-default v-else icon="close" size="is-small"></icon-default>
      <span :class="['checkbox_button--label', item.color]" style="margin-left: 4px">{{ item.label }}</span>
      <!--<span v-if="!isMobile" :class="['checkbox_button&#45;&#45;dot', item.color]"></span>-->
    </b-checkbox-button>
  </form-field>
</template>

<script>
export default {
  name: "FormFieldCheckboxButtons",
  props: {
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      checkboxGroup: this.value
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('change', val);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep .b-checkbox.checkbox.button {
  position: relative;
  background-color: transparent;
  border: none;
  padding-top: 1rem;
  padding-bottom: 1rem;

  &.is-white {
    background-color: $white;
  }

  &:focus {
    box-shadow: none;
  }
}

.checkbox_button--label {
  padding: 0 2px 1px;
  border-bottom: 2px solid transparent;

  &.is-notes {
    border-color: $notes;
  }

  &.is-calls {
    border-color: $calls;
  }

  &.is-texts {
    border-color: $texts;
  }

  &.is-emails {
    border-color: $emails;
  }

  &.is-activities {
    border-color: $activities;
  }
}

//.checkbox_button--dot {
//  position: absolute;
//  top: 4px;
//  right: 5px;
//  height: 10px;
//  width: 10px;
//  background-color: $primary;
//  border: 1px solid $white;
//  border-radius: 12px;
//
//  &.is-notes {
//    background-color: $notes;
//  }
//
//  &.is-calls {
//    background-color: $calls;
//  }
//
//  &.is-texts {
//    background-color: $texts;
//  }
//
//  &.is-emails {
//    background-color: $emails;
//  }
//
//  &.is-activities {
//    background-color: $activities;
//  }
//}
</style>
